import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Flickity from "flickity";
import "flickity-imagesloaded";
import Universal, { equalHeights } from "../utilities/universal";
import $ from "jquery";

gsap.registerPlugin(ScrollTrigger);

const SLIDER_COUNTDOWN = {
    duration: 5,
    interval: 10,
}

export default function Sliders() {
    $( initialiseAllSliders );
}

var isInitialised = false; 

export function initialiseAllSliders() { 
    if(isInitialised) {
        return;
    }

    isInitialised = true;

    if($(".global-slider").length) {
        const sliders = document.querySelectorAll('.global-slider');
        
        sliders.forEach((slider) => {
            let flkty_slider        = null;
            const equalHeightClass  = slider.querySelectorAll(".card-item")

            equalHeights(equalHeightClass);

            if (!window.acf) {
                flkty_slider = new Flickity (slider, {
                    cellAlign: "left",
                    wrapAround: false,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    watchCSS: true,
                    on: {
                        ready: () => {
                            equalHeights(equalHeightClass);
                        },
                        resize: () => {
                            equalHeights(equalHeightClass);
                        }
                    },
                    imagesLoaded: true
                })
            }

            window.addEventListener("resize", function () {
                equalHeightClass.forEach((sliderItem) => {
                    sliderItem.style.height = "auto";
                });

                flkty_slider.resize();
            });

            $(".prev-slide").off("click").on("click", function() {
                flkty_slider.previous();
            })
    
            $(".next-slide").off("click").on("click", function() {
                console.log("clicked");
                flkty_slider.next();
            })
        })
    }

    if($(".recent-blogs-flkty").length) {
        const $recent_blogs_slider = document.querySelector('.recent-blogs-flkty');
        const recent_blogs_flkty = new Flickity ($recent_blogs_slider, {
            cellAlign: "left",
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            watchCSS: true,
            on: {
                ready: () => {
                    Universal.equalHeights(".blog-item")
                },
                resize: () => {
                    Universal.equalHeights(".blog-item")
                }
            }
        })

        $( window ).on( "resize", function() {        
            $('.blog-item').each(function(){
                $(this).height("auto");
            });
    
            recent_blogs_flkty.resize();
        });

        $(".prev-blog").off("click").on("click", function() {
            recent_blogs_flkty.previous();
        })

        $(".next-blog").on("click", function() {
            recent_blogs_flkty.next();
        })
    }

    if ( $( ".tp-reviews-flkty" ).length ) {
        document.querySelectorAll( ".tp-reviews-flkty" ).forEach( function ( tp_reviews_slider ) {
            const tp_reviews_flkty = new Flickity(tp_reviews_slider, {
                cellAlign: "left",
                wrapAround: false,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                autoPlay: 4000,
                on: {
                    ready: () => {
                        Universal.equalHeights(".tp-review-item")
                    },
                    resize: () => {
                        Universal.equalHeights(".tp-review-item")
                    }
                }
            });
    
            $( window ).on( "resize", function() {        
                $('.tp-review-item').each(function(){
                    $(this).height("auto");
                });
        
                tp_reviews_flkty.resize();
            });
        } );
    }

    if($("#how-it-works-flkty").length) {
        const $hiw_slider = document.querySelector('#how-it-works-flkty');
        const hiw_slider = new Flickity($hiw_slider, {
            cellAlign: "left",
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: 4000,
            on: {
                ready: () => {
                    Universal.equalHeights(".hiw-item")
                },
                resize: () => {
                    Universal.equalHeights(".hiw-item")
                }
            }
        });

        $( window ).on( "resize", function() {        
            $('.hiw-item').each(function(){
                $(this).height("auto");
            });
    
            hiw_slider.resize();
        });
    }

    if($("#crypto-flkty").length) {
        const $crypto_slider = document.querySelector('#crypto-flkty');
        const crypto_slider = new Flickity($crypto_slider, {
            cellAlign: "left",
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            on: {
                ready: () => {
                    Universal.equalHeights(".crypto-item")
                },
                resize: () => {
                    Universal.equalHeights(".crypto-item")
                }
            }
        });

        $( window ).on( "resize", function() {        
            $('.crypto-item').each(function(){
                $(this).height("auto");
            });
    
            crypto_slider.resize();
        });
    }

    if($(".benefits-flkty").length) {
        const $benefits_slider = document.querySelector('.benefits-flkty');
        const benefits_flkty = new Flickity($benefits_slider, {
            cellAlign: "left",
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: 4000,
            watchCSS: true,
            on: {
                ready: () => {
                    Universal.equalHeights(".benefit-item")
                },
                resize: () => {
                    Universal.equalHeights(".benefit-item")
                }
            }
        });

        $( window ).on( "resize", function() {        
            $('.benefit-item').each(function(){
                $(this).height("auto");
            });
    
            benefits_flkty.resize();
        });
    }

    if($(".islamic-personal-finance-flkty").length) {
        const $islamic_personal_slider = document.querySelector('.islamic-personal-finance-flkty');
        const islamic_personal_slider = new Flickity ($islamic_personal_slider, {
            cellAlign: "left",
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            watchCSS: true,
            on: {
                ready: () => {
                    Universal.equalHeights(".ipf-stats-item")
                },
                resize: () => {
                    Universal.equalHeights(".ipf-stats-item")
                }
            }
        });

        $( window ).on( "resize", function() {        
            $('.ipf-stats-item').each(function(){
                $(this).height("auto");
            });
    
            islamic_personal_slider.resize();
        });
    }

    if($(".guides-flkty").length) {
        const $guides_slider = document.querySelector('.guides-flkty');
        const guides_slider = new Flickity ($guides_slider, {
            cellAlign: "left",
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            watchCSS: true,
            on: {
                ready: () => {
                    Universal.equalHeights(".guide-item")
                },
                resize: () => {
                    Universal.equalHeights(".guide-item")
                }
            }
        })

        $( window ).on( "resize", function() {        
            $('.guide-item').each(function(){
                $(this).height("auto");
            });
    
            guides_slider.resize();
        });

        $(".prev-guide").off("click").on("click", function() {
            guides_slider.previous();
        })

        $(".next-guide").off("click").on("click", function() {
            console.log("clicked");
            guides_slider.next();
        })
    }

    if($(".foreword-flkty").length) {
        const $foreword_slider = document.querySelector('.foreword-flkty');
        const foreword_slider = new Flickity ($foreword_slider, {
            cellAlign: "left",
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            adaptiveHeight: true,
            lazyLoad: true
        });

        $(".prev-foreword").off("click").on("click", function() {
            foreword_slider.previous();
        })

        $(".next-foreword").off("click").on("click", function() {
            foreword_slider.next();
        })
    }

    if($(".quotes-flkty").length) {
        // selector for flickity instance
        const $quotes_slider = document.querySelector('.quotes-flkty');

        // selector for the authors / dots
        const $pagers = $(".quotes-dots");

        // selector for the author item
        const $pager = $pagers.find(".quotes-dot");

        // circle size initially
        const pagerCircle = {
            r: 35.5,
            cx: 36,
            cy: 36
        }

        // configs for circle size through all breakpoints
        const breakpoints = [
            {
                "name": "mobile",
                'size': "(max-width: 419px)",
                r: 19.5,
                cx: 20,
                cy: 20
            },{
                "name": "xs",
                'size': "(min-width: 420px)",
                r: 23.5,
                cx: 24,
                cy: 24
            },{
                "name": "md",
                'size': "(min-width: 768px)",
                r: 26.5,
                cx: 27,
                cy: 27
            },{
                "name": "lg",
                'size': "(min-width: 1024px)",
                r: 29.5,
                cx: 32,
                cy: 32
            },
            {
                "name": "xl",
                'size': "(min-width: 1280px)",
                r: 35.5,
                cx: 36,
                cy: 36
            },
        ]

        // initialisation the circle size through all breakpoints
        // can be called the function in some cases, included on resize event
        function initTimerQuotes() {
            breakpoints.forEach((breakpoint) => {
                let size = window.matchMedia(breakpoint.size)
                
                if (size.matches) {
                    $pager.find('circle').attr('r', breakpoint.r)
                    $pager.find('circle').attr('cx', breakpoint.cx)
                    $pager.find('circle').attr('cy', breakpoint.cy)
                }

                size.addEventListener('change', event => {
                    if (event.matches) {
                        $pager.find('circle').attr('r', breakpoint.r)
                        $pager.find('circle').attr('cx', breakpoint.cx)
                        $pager.find('circle').attr('cy', breakpoint.cy)
                    }
                })
            })
        }

        // flickity initialisation
        const quotes_slider = new Flickity ($quotes_slider, {
            cellAlign: "left",
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: $(".quotes-item").length > 1 ? 5000 : false,
            pauseAutoPlayOnHover: false,
            adaptiveHeight: true,
            on: {
                ready: () => {
                    $pager.find('circle').attr('r', pagerCircle.r)
                    $pager.find('circle').attr('cx', pagerCircle.cx)
                    $pager.find('circle').attr('cy', pagerCircle.cy)
                },
                resize: () => {
                    initTimerQuotes()
                }
            }
        })
    
        // reset the circle dots animation if any changes triggered from the slider
        function resetDots() {
            $pager.find('circle').removeClass('animate-countdown');
            $pager.find('circle').attr('stroke', '#d3d8e2');
        }

        if (quotes_slider) {
            initTimerQuotes()

            // listen the flickity for selected slide item
            quotes_slider.on( 'select', function( index ) {
                resetDots();

                $pager.eq(index).find('circle').attr('stroke', '#305CFF')
                $pager.eq(index).find('circle').addClass('animate-countdown')
            });

            // re-init the circle animation and change the slider index if the author clicked
            $pagers.on('click', '.quotes-dot', function() {
                let index = $(this).index();
                quotes_slider.select(index);

                resetDots();
                $(this).find('circle').attr('stroke', '#305CFF')
                $(this).find('circle').addClass('animate-countdown')
            })

            // I'm not sure we need this
            // $quotes_slider.querySelectorAll('.quotes-item').forEach((elm, index) => {
            //     elm.addEventListener('mouseleave', function() {
            //         quotes_slider.playPlayer()

            //         resetDots();
            //         setTimeout(() => {
            //             $pager.eq(index).find('circle').attr('stroke', '#305CFF')
            //             $pager.eq(index).find('circle').addClass('animate-countdown')
            //         }, 100);
            //     }, false)
            // })
        }

        $( window ).on( "resize", function() {      
            quotes_slider.resize()
        })
    }

    if($(".authors-flkty").length) {
        // selector for flickity instance
        const $authors_slider = document.querySelector('.authors-flkty');

        // selector for the authors / dots
        const $pagers = $(".authors-dots");

        // selector for the author item
        const $pager = $pagers.find(".authors-dot");

        // some config for circle countdown
        let percentTime,
            step,
            tick,
            isPaused = false;

        // flickity initialisation
        const authors_slider = new Flickity ($authors_slider, {
            cellAlign: "left",
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: false,
            setGallerySize: false,
            pauseAutoPlayOnHover: false,
            adaptiveHeight: true,
            on: {
                ready: () => {
                    startProgressCircle(0)
                }
            }
        })

        function resetProgressCircle(index) {
            const progressValue = `--progress-value-${index}`
        
            gsap.set($pager.eq(index), {
                ease: "none",
                [progressValue]: "0deg"
            })

            clearTimeout(tick);
        }

        function increase(index) {
            if (!isPaused) {
                step = (SLIDER_COUNTDOWN.duration * 1000) / SLIDER_COUNTDOWN.interval;
                percentTime += 360 / step;
                const progressValue = `--progress-value-${index}`
                
                gsap.set($pager.eq(index), {
                    ease: "none",
                    [progressValue]: `${percentTime}deg`
                })

                if (percentTime >= 360) {
                    resetProgressCircle(index)

                    authors_slider.next();
                }
            }
        }

        function startProgressCircle(index) {
            percentTime = 0;
            isPaused = false;
            tick = window.setInterval(() => {
                increase(index)
            }, SLIDER_COUNTDOWN.interval);
        }

        // listen the flickity for selected slide item
        authors_slider.on( 'select', function( index ) {
            
            $pager.each(function(i) {
                const progressValue = `--progress-value-${i}`

                gsap.set($pager.eq(i), {
                    ease: "none",
                    [progressValue]: "0deg"
                })

                clearTimeout(tick)
            })

            startProgressCircle(index)
        });

        // re-init the circle animation and change the slider index if the author clicked
        $pagers.on('click', '.authors-dot', function() {
            $pager.each(function(i) {
                const progressValue = `--progress-value-${i}`

                gsap.set($pager.eq(i), {
                    ease: "none",
                    [progressValue]: "0deg"
                })

                clearTimeout(tick)
            })
            
            let index = $(this).index();
            authors_slider.select(index);
        })

        $( window ).on( "resize", function() {      
            authors_slider.resize()
        })
    }
}